<template>
<div class="dashboard__categories">

  <div class="scroll_button">
    <p>
      <img src="@/assets/img/triangle-bottom-blue.svg"/>
      Select categories in your state
      <img src="@/assets/img/triangle-bottom-blue.svg"/>
    </p>  
  </div>

  <div class="dashboard__categories_block">


    <div class="sidebar_menu">

      <div class="sidebar_menu__input">
        <text-input v-model="search" icon='search' placeholder='Search categories'></text-input>
      </div>

      <div class="sidebar_menu__links">
        <div class="link"
            v-for="(category, index) in categories"
            :key="index"
            @click="selectCategory(category)">
          <div class="icon">
            <img :src="`/img/categories/gray/${category.icon}.svg`"/>
          </div>
          <p class="text">
            {{ category.name }}
          </p>

        </div>
      </div>

    </div>


    <div class="categories__content">
      <div class="categories__content__top">
        <div class="action_blocks">
            <div class="icon" @click="show_mobile_menu = !show_mobile_menu">
              <img src="@/assets/img/burger-menu-point.svg" />
            </div>

          <div class="search">
            <text-input icon='search' 
                        v-model="search"
                        placeholder='Search'></text-input>
          </div>       
        </div>

        <div class="top_menu" v-if="show_mobile_menu">
          <div v-for="(category, index) in categories" 
               :key="index" 
               class="top_menu__element"
               @click="selectCategory(category)">
            <div class="icon">
              <img :src="`/img/categories/gray/${category.icon}.svg`"/>
            </div>

            <p class="text">{{ category.name }}</p>
          </div>
        </div>

        <div class="change_states">
          <div class="change_states__block">
            <span :class="[category_type === 'same' ? 'selected' : '']" @click="category_type = 'same'">Current state</span>
            <span @click="category_type = 'random'" :class="[category_type === 'random' ? 'selected' : '']">Random state</span>
          </div>
        </div>

      </div>

      <div class="categories__content__title">
        <p class="title">{{ category.name }}</p>
      </div>

      <div class="categories__content__plates">

        <div class="plates_list">
          <div class="plate_object" 
              v-for="(obj, index) in category_objects"
              :key="index"
              @click="selectPlate(obj.name)">
            <div class="plate_image">
              <img :src="`${static_server}img/plates_small/${category_type === 'same' ? $route.params.state : states[index]}.png`" />
              <p class="plate_text">{{ obj.name }}</p>
            </div>

            <div class="plate_description">
              <p class="category_name">{{ category.name }}</p>
              <small>Up to 7 characters</small>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>  
</template>

<script>
import { mapActions, mapState } from 'vuex'


export default {
  name: 'DashboardCategories',

  data() {
    return {
      search: '',
      category: {},
      category_objects: [],
      show_mobile_menu: false,

      category_type: 'same'
    }
  },

  computed: {
    ...mapState(['server', 'static_server', 'states', 'categories'])
  },

  mounted() {
    this.installParams()
    this.getCategory()
  },

  methods: {
    ...mapActions(['checkText']),
    installParams() {
      this.category = this.categories[0]
    },

    getCategory() {
      this.$axios.get(`${this.server}categories/${this.category.url}/`)
        .then((response) => {
          this.category_objects = response.data.objects
        })
    },

    selectCategory(category) {
      this.category = category
      this.getCategory()
      this.show_mobile_menu = false
    },

    selectPlate(text) {
      let usa_state = this.$route.params.state || getRandomInt
      this.$router.push(`/${usa_state}/${text}`)
    },

    // routeToText(text, state) {  
    //   let usa_state = state || getRandomInt
    //   router.push(`/plate/${usa_state}/${text}`)
    // }
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/style.sass"
</style>